import { Skeleton } from "@/styles/ui/skeleton";
import { cn } from "@/lib/utils";

export const CellAddressBadge = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "flex p-2 justify-center items-center rounded-[6px] bg-slate-100 w-8 h-8",
        className,
      )}
    >
      <span className="text-[#0A0A0A] caption-1-medium">
        {children ?? <Skeleton className="h-8 w-8 rounded-xl bg-neutral-100" />}
      </span>
    </div>
  );
};
